export default [
    {
        key: "dopolnitelnaya_polka",
        allArray: "allDopPolkaStoyka",
        activeArray: "activeDopPolkaStoyka",
        position: "bottom",
    },
];
